<template>
    <v-list dense>
        <v-simple-table dense>
            <thead>
                <tr>
                    <th v-if="$store.state.debugMode"></th>
                    <th class="text-center">#</th>
                    <th>Name</th>
                    <th>Club</th>
                    <th>Level</th>
                    <th>M/F</th>
                    <th>Age Group</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(athleteStart, index) in startLists" :key="athleteStart.id">
                    <td v-if="$store.state.debugMode">
                        <v-btn icon @click="deleteStartList(athleteStart)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </td>
                    <td class="text-center">
                        <start-list-order-edit
                            v-if="user?.is_admin"
                            :start-list="athleteStart"
                            :display-order="index + 1"
                        />
                        <span v-else>{{ index + 1 }}</span>
                    </td>
                    <td>
                        <inertia-link :href="athleteStart.athlete?.link">
                            <text-highlight v-if="sharedState.searchQuery" :queries="sharedState.searchQuery">
                                {{ athleteStart.athlete?.name }}
                            </text-highlight>
                            <span v-else>{{ athleteStart.athlete.name }}</span>
                        </inertia-link>
                        <template v-if="flightEvent === 'TS'">
                            <br />
                            <inertia-link :href="athleteStart.athlete2?.link">
                                <text-highlight v-if="sharedState.searchQuery" :queries="sharedState.searchQuery">
                                    {{ athleteStart.athlete2.name }}
                                </text-highlight>
                                <span v-else>{{ athleteStart.athlete2.name }}</span>
                            </inertia-link>
                        </template>
                    </td>
                    <td>
                        <inertia-link :href="athleteStart.club?.link">
                            <text-highlight v-if="sharedState.searchQuery" :queries="sharedState.searchQuery">
                                {{ athleteStart.club.name }}
                            </text-highlight>
                            <span v-else>{{ athleteStart.club?.name }}</span>
                        </inertia-link>
                        <template v-if="flightEvent === 'TS'">
                            <br />
                            <inertia-link :href="athleteStart.club2?.link">
                                <text-highlight v-if="sharedState.searchQuery" :queries="sharedState.searchQuery">
                                    {{ athleteStart.club2?.name }}
                                </text-highlight>
                                <span v-else>{{ athleteStart.club2?.name }}</span>
                            </inertia-link>
                        </template>
                    </td>
                    <td>{{ athleteStart.level }}</td>
                    <td>
                        <span v-if="athleteStart.gender.toUpperCase() === 'C'"> Mixed </span>
                        <span v-else>{{ athleteStart.gender.toUpperCase() }}</span>
                    </td>
                    <td>{{ athleteStart.age_group }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </v-list>
</template>

<script>
import TextHighlight from 'vue-text-highlight';
import get from 'lodash/get.js';
import Athlete from '@/Models/Athlete.js';
import StartListOrderEdit from '@/Components/StartListOrderEdit.vue';
import User from '@/Models/User.js';

export default {
    name: 'StartList',

    components: { StartListOrderEdit, TextHighlight },

    inject: ['sharedState'],

    props: {
        startLists: {
            type: Array,
            required: true,
        },

        flightEvent: {
            type: String,
            required: true,
        },
    },

    data: () => ({}),

    computed: {
        user() {
            return User.query().with('roles').find(this.$page.props.auth.user?.id);
        },

        searchedAthletes() {
            if (!get(this, 'sharedState.searchQuery')) {
                return [];
            }

            return Athlete.query()
                .where(
                    (athlete) =>
                        _.startsWith(athlete.first_name, this.sharedState.searchQuery) ||
                        _.startsWith(athlete.last_name, this.sharedState.searchQuery),
                )
                .get();
        },

        matchedAthletes() {
            return _.map(this.startLists, 'athlete');
        },
    },

    watch: {
        sharedState: {
            deep: true,
            handler({ searchQuery }) {
                if (searchQuery && this.searchedAthletes.length > 0) {
                    this.$emit('matchedQuery', this.searchedAthletes.length);
                } else {
                    this.$emit('noMatches');
                }
            },
        },
    },

    created() {
        if (!this.sharedState) {
            this.sharedState = {};
        }
    },

    methods: {
        get,

        async deleteStartList(athleteStart) {
            await axios.delete(`/api/start-lists/${athleteStart.id}`);

            athleteStart.$delete();
        },
    },
};
</script>
